export enum WorkspaceMemberTag {
  Safeguarding = 'Safeguarding',
}
